<template>
  <div>
    <!-- <div class="nav-item">
      <ul>
        <li v-for="(item,index) in nav" :key="index">
          <a href="#">{{item}}</a>
        </li>
      </ul>
    </div>-->
    <div class="nav-body">
      <div class="nav-content">
        <!-- 幻灯片 -->
        <div class="banner-top" @mouseenter="showBanner" @mouseleave="overBanner">
          <Carousel loop :arrow="bannerSetting.arrow" :autoplay="bannerSetting.autoplay"
            :autoplay-speed="bannerSetting.autoplaySpeed" :dots="bannerSetting.dots"
            :radius-dot="bannerSetting.radiusDot">
            <CarouselItem style="max-height: 455px;" v-for="(items, ins) in bannerTopList.banner" :key="ins">
              <router-link :to="{ path: items.ad_url }">
                <img @click="bannerLine(items.ad_name)" :src="items.img_url" :onerror="defaultGoodsImg" alt="图片破损" />
              </router-link>
            </CarouselItem>
          </Carousel>
        </div>
        <!-- <div class="banner-top">
          <img src="static\img\index\img\banner.png" alt="图片破损">
        </div> -->
        <!-- <div class="nav-show">
          <div class="nav-show-img" v-for="(item, index) in marketing.activity" :key="index">
            <router-link to="/goodsList">
              <img :src="item">
            </router-link>
          </div>
        </div> -->
        <div class="user-container">
          <div class="user-list">
            <div class="user-name">
              <div class="user-img">
                <img :src="avatarSrc" alt="" />
              </div>
              <div class="user-content">
                <div class="show-userName" v-show="uName">
                  <p class="hover-userName">
                    您好！{{ uName }}
                    <span class="user-icon"></span>
                  </p>
                  <p class="user-nickname">您好！{{ uName }}</p>
                </div>
                <div class="show-userName" v-show="!uName">
                  <p class="user-nickname">您好！请 <span class="noLogin"><router-link to="/login" style="color:#147A38"
                        class="allColor">登录</router-link> / <router-link to="/SignUp" style="color:#666" class="allColor">
                        注册 </router-link></span> </p>
                </div>
                <div class="show-userName" v-show="!uName">
                  <p class="hover-userName">
                    您好！欢迎来到民众在线
                    <span class="user-icon"></span>
                  </p>
                </div>
                <div class="user-content-1">
                  <a href="#" @click.prevent="toNewSpecialOffer" class="user-xrfl" v-if="new_customer1 == 1">新人福利</a>
                  <!-- <router-link to="/NewSpecialOffer" >新人福利</router-link> -->
                  <div class="user-content-item">
                    <div class="user-pd"><router-link to="/Sign">去签到</router-link></div>
                    <!--<div class="user-cs">
                      <p class="color33">您的专属客服</p>
                      <p>姓名：{{ userExclusive.username }}</p>
                      <p>电话：{{ userExclusive.phone }}</p>
                    </div>-->
                  </div>
                </div>
              </div>
            </div>
            <div class="user-item">
              <div class="user-item-content">
                <a target="_blank" href="http://jybg.ylmzyy.cn">
                  <img src="./../../../static/img/index/index_zjbg.png" alt="" />
                  <p class="user-item-txt">质检报告</p>
                </a>
              </div>
              <div class="user-item-content">
                <router-link to="/personal/MyOrder">
                  <img src="./../../../static/img/index/index_dzfp.png" alt="" />
                  <p class="user-item-txt">电子发票</p>
                </router-link>
              </div>
              <div class="user-item-content">
                <router-link to="/BuyingArea">
                  <img src="./../../../static/img/index/index_qgzq.png" alt="" />
                  <p class="user-item-txt">求购专区</p>
                </router-link>
              </div>
<!--              <div class="user-item-content">-->
<!--                <Dropdown placement="bottom-start" class="phone-code">-->
<!--&lt;!&ndash;                  <router-link to="/https://dow.gxmzzx.com">&ndash;&gt;-->
<!--&lt;!&ndash;                    <img src="./../../../static/img/index/index_sjb.png" alt="" />&ndash;&gt;-->
<!--&lt;!&ndash;                    <p class="user-item-txt">手机版</p>&ndash;&gt;-->
<!--&lt;!&ndash;                  </router-link>&ndash;&gt;-->
<!--                  <a href="https://dow.gxmzzx.com" target="_blank">-->
<!--                    <img src="./../../../static/img/index/index_sjb.png" alt="" />-->
<!--                    <p class="user-item-txt">手机版</p>-->
<!--                  </a>-->

<!--                  <DropdownMenu slot="list">-->
<!--                    <img src="static\img\index\img\分组 27.png" alt="" />-->
<!--                  </DropdownMenu>-->
<!--                </Dropdown>-->
<!--              </div>-->
              <div class="user-item-content">
                <router-link to="/Helps/HelpLogin?id=2">
                  <img src="./../../../static/img/index/index_qyzz.png" alt="" />
                  <p class="user-item-txt">企业资质</p>
                </router-link>
              </div>
              <div class="user-item-content">
                <router-link to="/Receive">
                  <img src="./../../../static/img/index/index_lqzx.png" alt="" />
                  <p class="user-item-txt">领劵中心</p>
                </router-link>
              </div>
              <div class="user-item-content">
                <router-link to="/PointsMall">
                  <img src="./../../../static/img/index/index_jfsc.png" alt="" />
                  <p class="user-item-txt">积分商城</p>
                </router-link>
              </div>

              <div class="user-item-content">
                <router-link to="/PointsyldMall">
                  <img src="./../../../static/img/index/dz.png" alt="" />
                  <p class="user-item-txt">游乐豆商城</p>
                </router-link>
              </div>

            </div>
            <div class="user-notice">
              <div class="user-cs">
                <p class="color33">您的专属客服</p>
                <p>姓名：{{ userExclusive.username }}</p>
                <p>电话：{{ userExclusive.phone }}</p>
              </div>
              <div v-if="userExclusive.wechat_qrcode" class="qrcode">
                <Tooltip placement="top">
                  <img alt="" :src="userExclusive.wechat_qrcode" width="50" height="50" />
                  <div slot="content" style="text-align: center">
                    <p>微信扫码添加您的专属客服企业微信</p>
                    <img alt="" :src="userExclusive.wechat_qrcode" width="200" height="200" />
                  </div>
                </Tooltip>
              </div>

              <!-- <div class="user-notice-content">
                <p class="user-notice-title">
                  <Icon type="ios-notifications" size="24" />
                  通知公告
                </p>
                <router-link to="/News" class="user-notice-more"
                  ><Icon type="ios-more" size="24"
                /></router-link>
              </div>
              <div class="swiper-com-container">
                <div class="notice-swiper">
                  &lt;!&ndash; Swiper 通知公告&ndash;&gt;
                  <div class="swiper-container">
                    <div class="swiper-wrapper">
                      <div
                        class="swiper-slide"
                        v-for="(item, index) in bannerTopList.message"
                        :key="index"
                      >
                        <p @click="goNoticeDetails(item)">{{ item.title }}</p>
                      </div>
                    </div>
                    &lt;!&ndash; Add Pagination &ndash;&gt;
                    &lt;!&ndash; <div class="swiper-pagination"></div>&ndash;&gt;
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import store from "@/vuex/store";
import { mapState, mapActions, mapGetters } from "vuex";
import { lineLocal } from '@/api/apiPot'
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
// import $ from "jquery";
import { getIndexTop } from "@/api/index";
export default {
  name: "HomeNav",
  data() {
    return {
      new_customer1: '',
      uName: "",
      bannerTopList: [], //banner列表
      userExclusive: "", //专属客服
      defaultGoodsImg:
        'this.src="' +
        require("../../../static/img/goodsList/goods_default_img.jpg") +
        '"',
      bannerSetting: {
        arrow: "hover",
        autoplay: true,
        autoplaySpeed: 5000,
        dots: "inside",
        radiusDot: true
      }
    };
  },
  computed: {
    ...mapState(["userInfo", 'new_customer']),
    ...mapGetters(["userName", "userAllData"]),
    avatarSrc() {
      let src = "/static/img/index/img/user.png";
      if (this.userAllData && this.userAllData.heads) {
        src = this.userAllData.heads.startsWith("http://")
          ? this.userAllData.heads
          : process.env.BASE_URL + this.userAllData.heads ||
          "/static/img/index/img/user.png";
      }
      return src;
    },
    zhijian() {
      let url = "http://221.2.68.62:10002";
      /* if (this.userAllData) {
         url+="?username="+this.userAllData.name+"&password="+this.userAllData.erpid;
       } */
      return url
    }
  },
  watch: {
    userName(newVal) {
      this.uName = newVal;
      console.log("userName-----变化", newVal);
    },
    new_customer(val) {
      console.log("val-----变化", val);
      this.new_customer1 = val
    }
  },
  mounted() {
    this.new_customer1 = sessionStorage.getItem('new_customer') + '' || this.userAllData.new_customer + ''
    this.uName = this.userName
    var mySwiper = new Swiper(".notice-swiper .swiper-container", {
      direction: "vertical",
      slidesPerView: 2, // 每页显示几个slide
      spaceBetween: 0, // slide的间距px
      followFinger: false, //
      speed: 1000, // 速度
      mousewheel: true, // 鼠标滚轮控制
      loop: $(".notice-swiper .swiper-slide").length > 2, // 循环
      autoplay: {
        delay: 1000,
        stopOnLastSlide: false,
        disableOnInteraction: true
      },
      pagination: {
        el: ".notice-swiper .swiper-pagination",
        clickable: true,
        dynamicBullets: true
      },
      navigation: {
        nextEl: ".notice-swiper .swiper-button-next",
        prevEl: ".notice-swiper .swiper-button-prev"
      }
    });
    // 鼠标移入停止自动滚动
    $(".notice-swiper .swiper-slide").mouseover(function () {
      mySwiper.autoplay.stop();
    });
    // 鼠标移出开始自动滚动
    $(".notice-swiper .swiper-slide").mouseout(function () {
      mySwiper.autoplay.start();
    });
    console.log("userName--mounted---变化", this.userName);
    this.uName = this.userName;
    this.bannerList();
  },
  methods: {
    ...mapActions(["signOut", "isLogin"]),
    bannerLine(e) {
      lineLocal({ source_type: 3, source_info: e })
    },
    showBanner() {
      /*鼠标移入轮播*/
      this.bannerSetting.autoplay = false;
      /*  console.log("-----变化1",this.bannerSetting.autoplay);*/
    },
    overBanner() {
      /*鼠标移出轮播*/
      this.bannerSetting.autoplay = true;
      /*console.log("-----变化2",this.bannerSetting.autoplay);*/
    },

    goNoticeDetails(item) {
      // 通知公告详情跳转
      console.log("公告详情", item);
      // /goodsDetail
      // this.$router.push({
      //     path: "/goodsDetail",
      //     query: { id: item.goods_id }
      // });
      window.open(this.$router.resolve({
        path: "/News/NewsDetails",
        query: { art_id: item.id }
      }).href, "_blank");

    },
    bannerList() {
      /**首页大banner+banner上用户信息 */
      let _this = this;
      console.log("获取首页banner");
      getIndexTop()
        .then(res => {
          console.log("获取首页banner", res);
          this.bannerTopList = res.data;
          if (res.data.manage == null) {
            this.userExclusive.username = "";
            this.userExclusive.phone = "";
            this.userExclusive.wechat_qrcode=""
          } else {
            this.userExclusive = res.data.manage;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    toNewSpecialOffer() {
      if (this.new_customer1 == 1) {
        console.log('1');
        this.$router.push({
          path: "/NewSpecialOffer"
        });
      } else {
        console.log(2);
        this.$message.error("你不是新用户，暂不可享受新人福利");
      }


    }
  },
  updated() {
    /* this.$refs.itemPanel1.style.left =
      this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + 'px';
    this.$refs.itemPanel2.style.left =
      this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + 'px';
    this.$refs.itemPanel1.style.top = this.$refs.navSide.offsetTop + 'px';
    this.$refs.itemPanel2.style.top = this.$refs.navSide.offsetTop + 'px';*/
  },
  store
};
</script>

<style lang="less" scoped>
.nav-item {
  width: 680px;
  height: 36px;
  margin: 0px auto;
}

.nav-item ul {
  list-style: none;
  margin-left: 15px;
}

.nav-item li {
  float: left;
  font-size: 16px;
  font-weight: bold;

  margin-left: 30px;
}

.nav-item a {
  text-decoration: none;
  color: #555555;
}

.nav-item a:hover {
  color: #d9534f;
}

/*大的导航信息，包含导航，幻灯片等*/
.nav-body {
  width: 100%;
  height: 540px;
  margin: 0 auto;
  position: relative;
}

.banner-top {
  min-height: 540px;

  img {
    width: 100%;
    background-size: 100% 100%;
  }
}

.banner-top /deep/ .ivu-carousel {
  min-height: 540px;
}

.banner-top /deep/ .ivu-carousel-list {
  text-align: center;
}

.banner-top /deep/ .ivu-carousel-dots li button.radius {
  width: 14px;
  height: 4px;
  border-radius: 5px;
  opacity: 1;
}

.banner-top /deep/ .ivu-carousel-dots li.ivu-carousel-active>button.radius {
  width: 20px;
}

.nav-side {
  width: 220px;
  height: 410px;
  padding: 0;
  color: #333;
  z-index: 10;
  position: absolute;
  top: 0;
  left: 352px;
  background: #fcfcfe;
  box-shadow: 0px 2px 8px 0px rgba(179, 179, 179, 0.2);
  border-radius: 10px 0 10px 10px;
}

.sort-list {
  .flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .img {
    width: 22px;
    height: 22px;
    margin: 0 8px 0 12px;
  }

  .img0 {
    background: url(./../../../static/img/index/indexIcon.png) no-repeat -14px -16px;
  }

  .img1 {
    background: url(./../../../static/img/index/indexIcon.png) no-repeat -48px -16px;
  }

  .img2 {
    background: url(./../../../static/img/index/indexIcon.png) no-repeat -82px -16px;
  }

  .img3 {
    background: url(./../../../static/img/index/indexIcon.png) no-repeat -116px -16px;
  }

  .img4 {
    background: url(./../../../static/img/index/indexIcon.png) no-repeat -150px -16px;
  }

  .img5 {
    background: url(./../../../static/img/index/indexIcon.png) no-repeat -184px -16px;
  }

  .img6 {
    background: url(./../../../static/img/index/indexIcon.png) no-repeat -218px -16px;
  }

  .img7 {
    background: url(./../../../static/img/index/indexIcon.png) no-repeat -252px -16px;
  }

  .img8 {
    background: url(./../../../static/img/index/indexIcon.png) no-repeat -286px -16px;
  }

  .img9 {
    background: url(./../../../static/img/index/indexIcon.png) no-repeat -320px -16px;
  }

  .img10 {
    background: url(./../../../static/img/index/indexIcon.png) no-repeat -14px -51px;
  }

  .img11 {
    background: url(./../../../static/img/index/indexIcon.png) no-repeat -48px -51px;
  }

  .img12 {
    background: url(./../../../static/img/index/indexIcon.png) no-repeat -155px -154px;
  }
}

.sort-list:first-child {
  border-radius: 10px 0 0 0;
}

.sort-list:last-child {
  border-radius: 0 0 0 10px;
}

.nav-side ul {
  width: 100%;
  padding: 0;
  list-style: none;
}

.nav-side li {
  height: 34px;
  line-height: 34px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  cursor: pointer;
  font-size: 12px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #333333;
}

.nav-side li:hover {
  background: #fff;
}

.nav-side-item:hover {
  cursor: pointer;
  color: #c81623;
}

/*导航内容*/
.nav-content {
  width: 100%;
}

.nav-content /deep/ .ivu-carousel-arrow.right {
  right: 360px;
}

.nav-content /deep/ .ivu-carousel-arrow.left {
  left: 620px;
}

.nav-content /deep/ .ivu-carousel-arrow {
  width: 60px;
  height: 60px;
  font-size: 2em;
  background-color: rgba(31, 45, 61, 0.6);
}

.nav-content /deep/ .ivu-carousel-dots-inside {
  display: block;
  position: absolute;
  bottom: 15%;
  left: 50%;
  transform: translate(-50%,0);
  width: 200px;
}

.nav-content /deep/ .ivu-carousel-dots li button {
  background-color: #147A38;
}

.nav-content /deep/ .ivu-icon {
  line-height: 2;
}

/*导航图片*/
.nav-show-img {
  margin-top: 10px;
  float: left;
}

.nav-show-img:nth-child(2) {
  margin-left: 12px;
}

/*显示商品*/
.content {
  width: 100%;
}

/*显示商品详细信息*/
.detail-item-panel {
  width: 540px;
  height: 410px;
  background-color: #fff;
  position: absolute;
  top: 131px;
  left: 572px;
  z-index: 999;
  overflow-x: hidden;
  overflow-y: scroll;
}

.detail-item-panel::-webkit-scrollbar {
  display: none;
}

.nav-detail-item {
  margin-left: 26px;
  margin-top: 15px;
  margin-bottom: 15px;
  cursor: pointer;
  color: #eee;
}

.nav-detail-item span {
  padding: 6px;
  padding-left: 12px;
  margin-left: 15px;
  font-size: 12px;
  background-color: #6e6568;
}

.nav-detail-item span:hover {
  margin-left: 15px;
  background-color: #f44336;
}

.detail-item-panel ul {
  list-style: none;
}

.detail-item-panel li {
  line-height: 25px;
  margin-left: 30px;
}

.detail-item-title {
  border-left: 2px solid #147A38;
  text-indent: 9px;
  margin-top: 12px;
  font-size: 14px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #333333;
  line-height: 14px;
}

.detail-item-title:hover {
  color: #147A38;
}

.detail-item-row a {
  color: #555555;
}

.detail-item-row .detail-item:first-child {}

.detail-item-row a .detail-item {
  padding: 0 14px;
  cursor: pointer;
  font-size: 12px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #666;
  line-height: 17px;
}

.detail-item-row a .detail-item {
  border-left: 1px solid #efefef;
  text-align: center;
}

.detail-item-row a:first-child .detail-item:first-child {
  display: inline-block;
  padding: 0 14px 0 0;
  border: none;
}

.three-classify {
  box-sizing: border-box;
  padding-top: 10px;
  border-top: 1px solid #efefef;
  margin-top: 10px;
}

.detail-item:hover {
  color: #147A38;
}

.classList {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;

  .flex {
    width: 50%;
  }
}

.one-classify {
  font-size: 16px;
  font-family: PingFangHK-Medium, PingFangHK;
  font-weight: 500;
  color: #147A38;
  line-height: 22px;
  padding: 26px 0 0 29px;
}

// 消息通知

/*用户信息*/
.user-container {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

.user-list {
  width: 1200px;
  margin: 0 auto;
  height: 110px;
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(179, 179, 179, 0.2);
  border-radius: 10px;
  z-index: 10;
  display: flex;
  display: -webkit-box;
  display: -ms-flexbox;
  position: absolute;
  left: 0;
  bottom: -26px;

  .user-name {
    display: flex;
    display: -webkit-box;
    display: -ms-flexbox;
    justify-content: space-between;
    margin-left: 30px;

    .user-img {
      width: 70px;
      height: 70px;
      margin-top: 20px;
      text-align: center;
      border-radius: 100%;

      img {
        width: 70px;
        height: 70px;
        border: 1px solid #e2e2e2;
        border-radius: 100%;
      }
    }

    .user-content {
      padding: 0 30px 0 19px;
      margin: 25px 0;
      border-right: 1px solid #efefef;
      position: relative;
    }

    .user-nickname {
      width: 140px;
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #666;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-top: 2px;
      cursor: pointer;
    }

    .hover-userName {
      display: none;
      position: absolute;
      top: -61px;
      left: 0;
      width: 150px;
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #666;
      line-height: 20px;
      background-color: #fff;
      box-sizing: border-box;
      padding: 7px 10px;
      -webkit-box-shadow: 0px 2px 8px 0px rgb(179 179 179 / 20%);
      box-shadow: 0px 2px 8px 0px rgb(179 179 179 / 20%);
      border-radius: 10px;
      text-align: center;
      box-sizing: border-box;
    }

    .show-userName {
      position: relative;

      .user-icon {
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid #fff;
        position: absolute;
        bottom: -5px;
        left: 70px;
      }
    }

    .show-userName:hover .hover-userName {
      display: block;
    }

    .user-content-1 {
      padding-top: 12px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;

      .user-content-item {
        position: relative;
        .user-cs {
          position: absolute;
          top: 158%;
          left: -77%;
          width: 180px;
          height: 130px;
          background-color: #fff;
          box-shadow: 0px 2px 8px 0px rgb(179 179 179 / 20%);
          color: #666;
          border-radius: 10px;
          font-size: 14px;
          box-sizing: border-box;
          padding: 20px 10px 10px 10px;
          display: none;

          p {
            padding-bottom: 10px;
          }

          .color33 {
            color: #333;
            font-weight: bold;
            padding-bottom: 10px;
          }
        }

        .user-cs::after {
          /*  content: "";
          position: absolute;
          left: 89px;
          top: -5%;
          width: 0;
          height: 0px;
          border-style: solid;
          border-width: 7px;
          border-color: #fff #fff transparent transparent;
          transform: rotate(-45deg);
          box-shadow: 3px -3px 3px rgba(216, 216, 216, 0.3);*/
        }
      }

      .user-content-item:hover .user-cs {
        display: block;
      }
    }

    .user-xrfl {
      border-radius: 6px;
      border: 1px solid #147A38;
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #147A38;
      box-sizing: border-box;
      padding: 1px 5px;
    }

    .user-pd {
      width: 70px;
      height: 26px;
      border-radius: 6px;
      border: 1px solid #147A38;
      // background: #676767;
      border-radius: 6px;
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #147A38;
      box-sizing: border-box;
      padding: 2px 5px;
      margin-left: 5px;
      cursor: pointer;
      text-align: center;

      a {
        color: #147A38;
      }
    }
  }

  .user-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-around;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    padding-top: 25px;
    padding-right: 50px;
    border-right: 1px solid #efefef;

    .user-item-content {
      padding-left: 35px;

    }

    .phone-code /deep/ .ivu-select-dropdown {
      margin: 0;
      padding: 0;
      background-color: rgba(255, 255, 255, 0);
      box-sizing: border-box;
      border-radius: 0;
      box-shadow: 0 0 0 rgb(0 0 0 / 20%);
      z-index: 900;
    }

    .user-item-txt {
      font-size: 12px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #000000;
      line-height: 17px;
      text-align: center;
    }
  }

  .user-notice {
    display: flex;
    justify-content: center;
    align-items: center;
    .qrcode{
      flex: 1;
    }

    /* flex: 1;*/
    .user-cs {
      flex: 4;
      /*position: absolute;*/
      /*top: 158%;*/
      /*left: -77%;*/
      /*width: 180px;*/
      /*height: 130px;*/
      /*  background-color: #fff;
      box-shadow: 0px 2px 8px 0px rgb(179 179 179 / 20%);*/
      color: #666;
      /*border-radius: 10px;*/
      font-size: 14px;
      box-sizing: border-box;
      padding: 20px 10px 10px 10px;

      /*display: none;*/
      p {
        padding-bottom: 10px;
      }

      .color33 {
        color: #333;
        font-weight: bold;
        padding-bottom: 10px;
      }
    }

    .user-cs::after {
      /* content: "";
      position: absolute;
      left: 89px;
      top: -5%;
      width: 0;
      height: 0px;
      border-style: solid;
      border-width: 7px;
      border-color: #fff #fff transparent transparent;
      transform: rotate(-45deg);
      box-shadow: 3px -3px 3px rgba(216, 216, 216, 0.3);*/
    }

    .user-notice-content {
      width: 288px;
      display: flex;
      display: -webkit-box;
      display: -ms-flexbox;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 17px 0 14px;
      border-bottom: 2px solid #efefef;
    }

    .user-notice-title {
      font-size: 16px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: #147A38;
      line-height: 22px;
    }

    .user-notice-more {
      text-align: right;
      color: #b3b3b3;
    }

    /* .swiper-com-container{*/
    /* 公告滚动 */
    .notice-swiper {
      width: 288px;
      position: relative;
      height: auto;
      padding: 10px 10px 10px 20px;
      margin: 0;
    }

    .notice-swiper .swiper-container {
      width: 100%;
      height: 40px;
    }

    .notice-swiper .swiper-slide {
      width: 258px;
      height: 20px;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .notice-swiper .swiper-slide p {
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;

    }

    .notice-swiper .swiper-pagination {
      position: absolute;
    }

    .notice-swiper .swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet {
      margin: 3px 0;
      display: block;
    }

    .swiper-container {
      width: 100%;
      /* height: 100%;*/
    }

    .swiper-slide {
      font-size: 12px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #666;
      line-height: 17px;
      /* background: #fff;*/
      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      /*        -webkit-box-pack: center;
                -ms-flex-pack: center;
                -webkit-justify-content: center;
                justify-content: center;
                -webkit-box-align: center;
                -ms-flex-align: center;
                -webkit-align-items: center;
                align-items: center;*/
    }

    /*  }*/
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nav/HomeNav.vue